import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { pick } from 'lodash-es'
import { Loader, LoadingOverlay, Text } from '@mantine/core'
import { getQuery } from '@vt/utils'
import { transformAppId } from '@vt/apis/lib-ex'
import { getInformationStorage } from '@vt/apis/lib-ex/v2/login'
// import { getQuery } from '@vt/utils'
import { Button, Toast } from '@ow/comps'
import { IconMaps } from '@ow/icons'
import { useProjectStore } from '@vt/hooks'
import PasswordLogin from './PasswordLogin'
import CodeLogin from './CodeLogin'
import DDLogin from './DDLogin'
import useRouteTo from '../../hooks/navigation/use-route-to'
import ddImg from '../assets/dd.png'

const Content = function ({
  prefix,
  onRegister,
  useLoginApi,
  loginCallBack,
  // 用来判断登录方式
  allowLoginType = [],
}) {
  const { code } = getQuery()
  const { cusKey: key } = useProjectStore((s) => pick(s, ['cusKey']))
  console.log(key, 'cusKey')
  // FIXME:这里其实不太对，key 和 appId 并不是一一对应，这里 key 可能对应多个 appID
  // 对于：appID 只有一个情况，可以直接跳到 app
  // 否则：跳到 app list 页面
  const appId = transformAppId[key]
  const { routeTo } = useRouteTo({ appId })
  const [isDDLogin, setIsDDLogin] = useState(false)
  const [isVerify, setIsVerify] = useState(false)
  const location = useLocation()
  const navigate = useNavigate()

  const { loginType, onChangeLoginType, onUserLogin, onDDLogin, getPassword } =
    useLoginApi
  const isLoginByDD = loginType === 'dingding'
  const isShowDDLogin = allowLoginType.includes('dingding')
  // 是否切换到验证码登录
  const isChangeToCodeLogin =
    allowLoginType.includes('code') && loginType === 'password'
  // 是否切换到账号密码登录
  const isChangeToPasswordLogin =
    (allowLoginType.includes('tel') && loginType === 'code') ||
    loginType === 'dingding'

  const afterLogin = (res) => {
    if (location.state?.from) {
      const { pathname, search } = location.state.from
      return navigate(pathname + search, { replace: true })
    }

    if (key) {
      return getInformationStorage(transformAppId[key], key)
        .then((result) => {
          setIsVerify(false)
          const PWD_REG =
            // eslint-disable-next-line no-useless-escape
            /^(?=.*[A-Za-z])(?=.*\d)(?=.*[`~!@#$%^&*()_+<>?:"{},.\/\\;'[\]])[A-Za-z\d`~!@#$%^&*()_+<>?:"{},.\/\\;'[\]]{8,16}$/
          if (!PWD_REG.test(getPassword())) {
            Toast.info({
              title: '提示',
              description:
                '密码强度低，请联系管理员及时修改为强密码格式：8-16个字符，必须包含符号、数字和大小写字母组合！',
            })
          }
          if (!result.value) {
            Toast.error({
              title: '提示',
              description: '您没有访问权限，请联系管理员',
            })
            return
          }
          const redirectUrl = result.value.url || {}
          if (loginCallBack) {
            loginCallBack(res, () => {
              routeTo(redirectUrl)
            })
          }
        })
        .catch((error) => {
          setIsVerify(false)
          Toast.error({
            title: '提示',
            description: error.message,
          })
        })
    }

    return routeTo(`app-list?token=${res}`)
  }

  useEffect(() => {
    if (code) {
      setIsDDLogin(true)
      setIsVerify(true)
      onDDLogin(code, 'syhjws', afterLogin, (msg) => {
        Toast.error({
          title: '提示',
          description: msg,
        })
        setIsDDLogin(false)
        setIsVerify(false)
      })
        .then(() => {
          setIsDDLogin(false)
        })
        .catch(() => {
          setIsDDLogin(false)
        })
    }
  }, [])

  return (
    <div className={`${prefix}-loginBox login-box-${prefix}`}>
      {/* 切换到验证码登录 */}
      {isChangeToCodeLogin && (
        <div onClick={onChangeLoginType} className={`${prefix}-to-code-login`}>
          <div>
            <IconMaps
              type="loginByPhoneIcon"
              width={32}
              height={32}
              fill="white"
            />
          </div>
        </div>
      )}
      {/* 切换到密码登录 */}
      {isChangeToPasswordLogin && (
        <div onClick={onChangeLoginType} className={`${prefix}-to-code-login`}>
          <div>
            <IconMaps
              type="loginByPasswordIcon"
              width={32}
              height={32}
              fill="white"
            />
          </div>
        </div>
      )}
      <p className={`${prefix}-login-title`}>
        {loginType === 'password' && '密码登录'}
        {loginType === 'code' && '验证码登录'}
        {loginType === 'dingding' && '钉钉扫码登录'}
      </p>
      <div className={`${prefix}-inputGroupBox`}>
        {loginType === 'password' && (
          <PasswordLogin
            prefix={prefix}
            useLoginApi={useLoginApi}
            loginCallBack={afterLogin}
          />
        )}
        {loginType === 'code' && (
          <CodeLogin prefix={prefix} useLoginApi={useLoginApi} />
        )}
        {loginType === 'dingding' && <DDLogin />}

        {!key && (
          <div
            className="w-full flex items-center mt-3 text-blue-1 font-semibold cursor-pointer"
            onClick={onRegister}
          >
            注册新账号
          </div>
        )}
        {!isLoginByDD && (
          <div className="w-full flex items-center justify-center lg:justify-start flex-col">
            <Button
              className={`${prefix}-loginBtn button`}
              onClick={() => {
                onUserLogin(afterLogin)
              }}
            >
              登录
            </Button>

            {isShowDDLogin && (
              <div
                className="flex items-center mt-4 cursor-pointer"
                onClick={() => {
                  onChangeLoginType('dingding')
                }}
              >
                <span style={{ fontSize: '16px' }}>使用钉钉扫码登录</span>
                <img src={ddImg} alt="" className="dd-icon" />
              </div>
            )}
          </div>
        )}

        <div className="login-bottom-tip">
          建议使用
          <span className="blue-span">Chrome 70</span>
          以上版本、
          <span className="blue-span">IE Edge</span>
          版本
        </div>
      </div>
      <LoadingOverlay
        loader={
          <div className="flex flex-col justify-center gap-5 items-center">
            <Loader size={60} />
            <Text fz="xl" fw={700}>
              正在登录...
            </Text>
          </div>
        }
        visible={isDDLogin || isVerify}
        overlayBlur={5}
        transitionDuration={500}
      />
    </div>
  )
}
export default Content
